module.exports = __webpack_public_path__ + "img/pos-icon.3b0f7cb8.gif";